import { BsRecord2 } from "react-icons/bs";
import { useRecordingId } from "../../hooks/recording";
import { useRoom } from "../context/room/room";
import { RadixRecordingDialog } from "./dialogs/RecordingDialog";
import classNames from "./RecordingStatus.module.css";
import { useIsMobile } from "../../hooks/layout";

const RecordingStatus = (props: { hide?: boolean }) => {
  const { room, organization } = useRoom();
  const recordingId = useRecordingId();

  const isMobile = useIsMobile();

  if (!room || !organization) {
    return null;
  }

  // Always show when recording is in progress
  if ((props.hide || !organization.recording_enabled) && !recordingId) {
    return null;
  }

  if (isMobile) {
    return null;
  }

  return (
    <h3 className={classNames.RecordingStatus}>
      <BsRecord2 color={!recordingId ? "white" : "var(--langfinity-red)"} />
      {!recordingId ? "Start recording" : "Recording in progress"}
      <RadixRecordingDialog
        trigger={<button>{!recordingId ? "Click to start" : "Stop"}</button>}
        roomId={room.id}
        start={!recordingId}
      />
    </h3>
  );
};

export default RecordingStatus;
